//
//
//
//
//
//
//
//

export default {
  name: 'InvalidFeedback',
  props: {
    errors: {
      type: Array,
      default: () => []
    }
  }
};
